import { native, type UserInfo } from '@forest/native-services'
import { AbortError, ensureAuthenticatedUser } from '@forest/paywall-core'
import { userInfoSource } from '~/store/user-info'

export { AbortError }

export async function getAuthenticatedUserInfo(options?: {
  onAfterGuestUpgrade?: () => Promise<void> | void
}): Promise<UserInfo> {
  return ensureAuthenticatedUser({
    getUserInfo: async () => {
      const result = await native.user.getUserInfo()
      if (!result.success) throw new Error('getUserInfo failed')
      if (!result.data) throw new Error('getUserInfo returned null data')
      return { success: true as const, data: result.data }
    },
    auth: () => native.auth.auth(),
    bindLegacyUser: () => native.auth.bindLegacyUser(),
    onAfterGuestUpgrade: options?.onAfterGuestUpgrade,
    onLegacyBindStart: () => {
      window.dispatchEvent(new CustomEvent('hide-close-button'))
    },
    onLegacyBindEnd: () => {
      window.dispatchEvent(new CustomEvent('show-close-button'))
    },
    onUserInfo: (nextUserInfo) => {
      userInfoSource.atom.set(nextUserInfo)
    },
  })
}
